import { __decorate, __param } from 'tslib';
import { Optional, Self, Inject, ChangeDetectorRef, ViewChild, Input, ContentChildren, HostListener, Component, ChangeDetectionStrategy, forwardRef, Directive, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AbstractTuiNullableControl, EMPTY_QUERY, TUI_IS_IOS, tuiDefaultProp, TUI_FOCUSABLE_ITEM_ACCESSOR, AbstractTuiControl, TuiMapperPipeModule } from '@taiga-ui/cdk';
import { tuiCreateNumberMask, tuiEnableAutoCorrectDecimalSymbol, tuiCreateAutoCorrectedNumberPipe, maskedMoneyValueIsEmpty, maskedNumberStringToNumber, TUI_DECIMAL_SYMBOLS, getFractionPartPadded, formatNumber, TUI_NUMBER_FORMAT, TuiPrimitiveTextfieldComponent, TuiAbstractTextfieldHost, TUI_TEXTFIELD_HOST, TuiPrimitiveTextfieldModule, TuiTextfieldControllerModule, TuiTextfieldComponent } from '@taiga-ui/core';
import { PolymorpheusOutletComponent, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { CommonModule } from '@angular/common';
import { TuiValueAccessorModule } from '@taiga-ui/kit/directives';
import { TextMaskModule } from 'angular2-text-mask';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@taiga-ui/kit/directives';
import * as ɵngcc3 from 'angular2-text-mask';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc6 from '@taiga-ui/cdk';
import * as ɵngcc7 from '@angular/forms';

function TuiInputNumberComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("content", _r2);
} }
function TuiInputNumberComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiInputNumberComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 2);
} }
const _c0 = ["*", [["input"]], [["", "polymorpheus-outlet", ""]]];
const _c1 = function (a0, a1, a2, a3, a4) { return [a0, a1, a2, a3, a4]; };
const _c2 = ["*", "input", "[polymorpheus-outlet]"];
var TuiInputNumberComponent_1;
const DEFAULT_MAX_LENGTH = 18;
// @dynamic
let TuiInputNumberComponent = TuiInputNumberComponent_1 = class TuiInputNumberComponent extends AbstractTuiNullableControl {
    constructor(control, changeDetectorRef, numberFormat, isIOS) {
        super(control, changeDetectorRef);
        this.numberFormat = numberFormat;
        this.isIOS = isIOS;
        this.min = -Infinity;
        this.max = Infinity;
        this.decimal = 'not-zero';
        this.precision = 2;
        this.prefix = '';
        this.postfix = '';
        this.polymorpheusValueContent = EMPTY_QUERY;
        this.mask = (allowNegative, decimal, decimalLimit, nativeFocusableElement) => ({
            mask: tuiCreateNumberMask({
                allowNegative,
                decimalLimit,
                allowDecimal: decimal !== 'never',
                requireDecimal: decimal === 'always',
                decimalSymbol: this.numberFormat.decimalSeparator,
                thousandSymbol: this.numberFormat.thousandSeparator,
                autoCorrectDecimalSymbol: tuiEnableAutoCorrectDecimalSymbol(this.numberFormat),
            }),
            pipe: tuiCreateAutoCorrectedNumberPipe(decimal === 'always' ? decimalLimit : 0, this.numberFormat.decimalSeparator, this.numberFormat.thousandSeparator, nativeFocusableElement, allowNegative, this.isIOS),
            guide: false,
        });
    }
    get nativeFocusableElement() {
        return !this.primitiveTextfield || this.computedDisabled
            ? null
            : this.primitiveTextfield.nativeFocusableElement;
    }
    get focused() {
        return !!this.primitiveTextfield && this.primitiveTextfield.focused;
    }
    get isNegativeAllowed() {
        return this.min < 0;
    }
    get inputMode() {
        return this.decimal === 'never' ? 'numeric' : 'decimal';
    }
    get calculatedMaxLength() {
        const decimalPart = this.decimal !== 'never' &&
            this.nativeValue.includes(this.numberFormat.decimalSeparator);
        const precision = decimalPart ? this.precision + 1 : 0;
        const takeThousand = this.numberFormat.thousandSeparator.repeat(5).length;
        return DEFAULT_MAX_LENGTH + precision + takeThousand;
    }
    get formattedValue() {
        return this.getFormattedValue(this.value || 0);
    }
    get computedValue() {
        if (this.focused) {
            return this.nativeValue;
        }
        return this.value === null ? '' : this.formattedValue;
    }
    onZero(event) {
        const decimal = this.nativeValue.split(this.numberFormat.decimalSeparator)[1] || '';
        const { nativeFocusableElement } = this;
        if (decimal.length < this.precision ||
            !nativeFocusableElement ||
            !nativeFocusableElement.selectionStart ||
            this.nativeValue[nativeFocusableElement.selectionStart] !== '0') {
            return;
        }
        event.preventDefault();
        nativeFocusableElement.selectionStart++;
    }
    onValueChange(value) {
        if (maskedMoneyValueIsEmpty(value)) {
            this.updateValue(null);
            return;
        }
        if (this.isNativeValueNotFinished) {
            return;
        }
        const capped = this.absoluteCapInputValue(value);
        if (capped === null || isNaN(capped)) {
            return;
        }
        this.updateValue(capped);
        if (capped !==
            maskedNumberStringToNumber(value, this.numberFormat.decimalSeparator, this.numberFormat.thousandSeparator)) {
            this.nativeValue = this.formattedValue;
        }
    }
    onKeyDown(event) {
        if (!TUI_DECIMAL_SYMBOLS.includes(event.key)) {
            return;
        }
        if (this.decimal === 'never') {
            event.preventDefault();
            return;
        }
        if (this.nativeValue.includes(this.numberFormat.decimalSeparator)) {
            event.preventDefault();
            this.setCaretAfterComma();
        }
    }
    onFocused(focused) {
        this.updateFocused(focused);
        if (focused) {
            return;
        }
        const nativeNumberValue = this.nativeNumberValue;
        if (isNaN(nativeNumberValue)) {
            this.clear();
            return;
        }
        const clamped = Math.min(this.max, Math.max(this.min, nativeNumberValue));
        this.updateValue(clamped);
        this.nativeValue = this.formattedValue;
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onPressed(pressed) {
        this.updatePressed(pressed);
    }
    getFormattedValue(value) {
        const absValue = Math.abs(value);
        const hasFraction = absValue % 1 > 0;
        let limit = this.decimal === 'always' || hasFraction ? this.precision : 0;
        const fraction = hasFraction ? getFractionPartPadded(value, this.precision) : '';
        if (this.focused && this.decimal !== 'always') {
            limit = fraction.length;
        }
        return formatNumber(value, limit, this.numberFormat.decimalSeparator, this.numberFormat.thousandSeparator, this.numberFormat.zeroPadding);
    }
    get isNativeValueNotFinished() {
        const nativeNumberValue = this.nativeNumberValue;
        return nativeNumberValue < 0
            ? nativeNumberValue > this.max
            : nativeNumberValue < this.min;
    }
    get nativeValue() {
        return this.nativeFocusableElement ? this.nativeFocusableElement.value : '';
    }
    set nativeValue(value) {
        if (!this.primitiveTextfield || !this.nativeFocusableElement) {
            return;
        }
        this.primitiveTextfield.value = value;
        this.nativeFocusableElement.value = value;
    }
    get nativeNumberValue() {
        return maskedNumberStringToNumber(this.nativeValue, this.numberFormat.decimalSeparator, this.numberFormat.thousandSeparator);
    }
    clear() {
        this.nativeValue = '';
        this.updateValue(null);
    }
    absoluteCapInputValue(inputValue) {
        const value = maskedNumberStringToNumber(inputValue, this.numberFormat.decimalSeparator, this.numberFormat.thousandSeparator);
        const capped = value < 0
            ? Math.max(Math.max(this.min, Number.MIN_SAFE_INTEGER), value)
            : Math.min(value, Math.min(this.max, Number.MAX_SAFE_INTEGER));
        const ineligibleValue = isNaN(capped) || capped < this.min || capped > this.max;
        return ineligibleValue ? null : capped;
    }
    setCaretAfterComma() {
        if (!this.nativeFocusableElement) {
            return;
        }
        const afterCommaPosition = this.nativeValue.length - this.precision;
        this.nativeFocusableElement.setSelectionRange(afterCommaPosition, afterCommaPosition);
    }
};
TuiInputNumberComponent.ɵfac = function TuiInputNumberComponent_Factory(t) { return new (t || TuiInputNumberComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TUI_NUMBER_FORMAT), ɵngcc0.ɵɵdirectiveInject(TUI_IS_IOS)); };
TuiInputNumberComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiInputNumberComponent, selectors: [["tui-input-number"]], contentQueries: function TuiInputNumberComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, PolymorpheusOutletComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.polymorpheusValueContent = _t);
    } }, viewQuery: function TuiInputNumberComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiPrimitiveTextfieldComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.primitiveTextfield = _t.first);
    } }, hostBindings: function TuiInputNumberComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown.0", function TuiInputNumberComponent_keydown_0_HostBindingHandler($event) { return ctx.onZero($event); });
    } }, inputs: { min: "min", max: "max", decimal: "decimal", precision: "precision", prefix: "prefix", postfix: "postfix" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiInputNumberComponent_1)
            },
            {
                provide: AbstractTuiControl,
                useExisting: forwardRef(() => TuiInputNumberComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2, decls: 9, vars: 28, consts: [["tuiValueAccessor", "", "tuiTextfieldInputMode", "decimal", 1, "textfield", 3, "pseudoHovered", "pseudoFocused", "pseudoPressed", "invalid", "tuiTextfieldMaxLength", "readOnly", "disabled", "textMask", "value", "prefix", "postfix", "focusable", "valueChange", "hoveredChange", "focusedChange", "pressedChange", "keydown"], ["polymorpheus-outlet", "", "class", "t-value-content", 3, "content", 4, "ngIf"], [4, "ngIf"], ["valueContent", ""], ["polymorpheus-outlet", "", 1, "t-value-content", 3, "content"]], template: function TuiInputNumberComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "tui-primitive-textfield", 0);
        ɵngcc0.ɵɵlistener("valueChange", function TuiInputNumberComponent_Template_tui_primitive_textfield_valueChange_0_listener($event) { return ctx.onValueChange($event); })("hoveredChange", function TuiInputNumberComponent_Template_tui_primitive_textfield_hoveredChange_0_listener($event) { return ctx.onHovered($event); })("focusedChange", function TuiInputNumberComponent_Template_tui_primitive_textfield_focusedChange_0_listener($event) { return ctx.onFocused($event); })("pressedChange", function TuiInputNumberComponent_Template_tui_primitive_textfield_pressedChange_0_listener($event) { return ctx.onPressed($event); })("keydown", function TuiInputNumberComponent_Template_tui_primitive_textfield_keydown_0_listener($event) { return ctx.onKeyDown($event); });
        ɵngcc0.ɵɵpipe(1, "tuiMapper");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵprojection(3, 1, ["ngProjectAs", "input", 5, ["input"]]);
        ɵngcc0.ɵɵtemplate(4, TuiInputNumberComponent_div_4_Template, 1, 1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TuiInputNumberComponent_ng_container_5_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵpipe(6, "async");
        ɵngcc0.ɵɵtemplate(7, TuiInputNumberComponent_ng_template_7_Template, 1, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("pseudoHovered", ctx.computedHovered)("pseudoFocused", ctx.computedFocused)("pseudoPressed", ctx.computedPressed)("invalid", ctx.computedInvalid)("tuiTextfieldMaxLength", ctx.calculatedMaxLength)("readOnly", ctx.readOnly)("disabled", ctx.computedDisabled)("textMask", ɵngcc0.ɵɵpipeBindV(1, 14, ɵngcc0.ɵɵpureFunction5(22, _c1, ctx.isNegativeAllowed, ctx.mask, ctx.decimal, ctx.precision, ctx.nativeFocusableElement)))("value", ctx.computedValue)("prefix", ctx.prefix)("postfix", ctx.postfix)("focusable", ctx.focusable);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.polymorpheusValueContent.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(6, 20, ctx.polymorpheusValueContent.changes));
    } }, directives: [ɵngcc1.TuiPrimitiveTextfieldComponent, ɵngcc1.TuiPrimitiveTextfieldDirective, ɵngcc2.TuiValueAccessorDirective, ɵngcc1.TuiTextfieldInputModeDirective, ɵngcc1.TuiTextfieldMaxLengthDirective, ɵngcc3.MaskedInputDirective, ɵngcc4.NgIf, ɵngcc5.PolymorpheusOutletComponent], pipes: [ɵngcc6.TuiMapperPipe, ɵngcc4.AsyncPipe], styles: ["[_nghost-%COMP%]{display:block;border-radius:var(--tui-radius-m);text-align:left}.textfield[_ngcontent-%COMP%]{border-radius:inherit;text-align:inherit}.t-value-content[_ngcontent-%COMP%]{width:100%}"], changeDetection: 0 });
TuiInputNumberComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_NUMBER_FORMAT,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_IOS,] }] }
];
__decorate([
    ViewChild(TuiPrimitiveTextfieldComponent)
], TuiInputNumberComponent.prototype, "primitiveTextfield", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputNumberComponent.prototype, "min", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputNumberComponent.prototype, "max", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputNumberComponent.prototype, "decimal", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputNumberComponent.prototype, "precision", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputNumberComponent.prototype, "prefix", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputNumberComponent.prototype, "postfix", void 0);
__decorate([
    ContentChildren(PolymorpheusOutletComponent)
], TuiInputNumberComponent.prototype, "polymorpheusValueContent", void 0);
__decorate([
    HostListener('keydown.0', ['$event'])
], TuiInputNumberComponent.prototype, "onZero", null);
TuiInputNumberComponent = TuiInputNumberComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef)),
    __param(2, Inject(TUI_NUMBER_FORMAT)),
    __param(3, Inject(TUI_IS_IOS))
], TuiInputNumberComponent);

var TuiInputNumberDirective_1;
let TuiInputNumberDirective = TuiInputNumberDirective_1 = class TuiInputNumberDirective extends TuiAbstractTextfieldHost {
    get value() {
        return this.host.computedValue;
    }
    onValueChange(value) {
        this.host.onValueChange(value);
    }
    process(input) {
        this.input = input;
    }
    ngDoCheck() {
        if (!this.input) {
            return;
        }
        this.input.maxLength = this.host.calculatedMaxLength;
        this.input.inputMode = 'decimal';
    }
};
TuiInputNumberDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiInputNumberDirective_BaseFactory; return function TuiInputNumberDirective_Factory(t) { return (ɵTuiInputNumberDirective_BaseFactory || (ɵTuiInputNumberDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiInputNumberDirective)))(t || TuiInputNumberDirective); }; }();
TuiInputNumberDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiInputNumberDirective, selectors: [["tui-input-number"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_HOST,
                useExisting: forwardRef(() => TuiInputNumberDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });

let TuiInputNumberModule = class TuiInputNumberModule {
};
TuiInputNumberModule.ɵfac = function TuiInputNumberModule_Factory(t) { return new (t || TuiInputNumberModule)(); };
TuiInputNumberModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiInputNumberModule });
TuiInputNumberModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TextMaskModule,
            TuiMapperPipeModule,
            TuiPrimitiveTextfieldModule,
            TuiTextfieldControllerModule,
            TuiValueAccessorModule,
            PolymorpheusModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputNumberComponent, [{
        type: Component,
        args: [{
                selector: 'tui-input-number',
                template: "<tui-primitive-textfield\n    tuiValueAccessor\n    tuiTextfieldInputMode=\"decimal\"\n    class=\"textfield\"\n    [pseudoHovered]=\"computedHovered\"\n    [pseudoFocused]=\"computedFocused\"\n    [pseudoPressed]=\"computedPressed\"\n    [invalid]=\"computedInvalid\"\n    [tuiTextfieldMaxLength]=\"calculatedMaxLength\"\n    [readOnly]=\"readOnly\"\n    [disabled]=\"computedDisabled\"\n    [textMask]=\"isNegativeAllowed | tuiMapper: mask:decimal:precision:nativeFocusableElement\"\n    [value]=\"computedValue\"\n    [prefix]=\"prefix\"\n    [postfix]=\"postfix\"\n    [focusable]=\"focusable\"\n    (valueChange)=\"onValueChange($event)\"\n    (hoveredChange)=\"onHovered($event)\"\n    (focusedChange)=\"onFocused($event)\"\n    (pressedChange)=\"onPressed($event)\"\n    (keydown)=\"onKeyDown($event)\"\n>\n    <ng-content></ng-content>\n    <ng-content\n        select=\"input\"\n        ngProjectAs=\"input\"\n    ></ng-content>\n    <div\n        *ngIf=\"polymorpheusValueContent.length\"\n        polymorpheus-outlet\n        class=\"t-value-content\"\n        [content]=\"valueContent\"\n    ></div>\n</tui-primitive-textfield>\n\n<ng-container *ngIf=\"polymorpheusValueContent.changes | async\"></ng-container>\n\n<ng-template #valueContent>\n    <ng-content select=\"[polymorpheus-outlet]\"></ng-content>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiInputNumberComponent_1)
                    },
                    {
                        provide: AbstractTuiControl,
                        useExisting: forwardRef(() => TuiInputNumberComponent_1)
                    },
                ],
                styles: [":host{display:block;border-radius:var(--tui-radius-m);text-align:left}.textfield{border-radius:inherit;text-align:inherit}.t-value-content{width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc7.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_NUMBER_FORMAT]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_IOS]
            }] }]; }, { min: [{
            type: Input
        }], max: [{
            type: Input
        }], decimal: [{
            type: Input
        }], precision: [{
            type: Input
        }], prefix: [{
            type: Input
        }], postfix: [{
            type: Input
        }], polymorpheusValueContent: [{
            type: ContentChildren,
            args: [PolymorpheusOutletComponent]
        }], onZero: [{
            type: HostListener,
            args: ['keydown.0', ['$event']]
        }], primitiveTextfield: [{
            type: ViewChild,
            args: [TuiPrimitiveTextfieldComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputNumberDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-input-number',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_HOST,
                        useExisting: forwardRef(() => TuiInputNumberDirective_1)
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputNumberModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TextMaskModule,
                    TuiMapperPipeModule,
                    TuiPrimitiveTextfieldModule,
                    TuiTextfieldControllerModule,
                    TuiValueAccessorModule,
                    PolymorpheusModule,
                ],
                declarations: [TuiInputNumberComponent, TuiInputNumberDirective],
                exports: [TuiInputNumberComponent, TuiInputNumberDirective, TuiTextfieldComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiInputNumberModule, { declarations: function () { return [TuiInputNumberComponent, TuiInputNumberDirective]; }, imports: function () { return [CommonModule,
        TextMaskModule,
        TuiMapperPipeModule,
        TuiPrimitiveTextfieldModule,
        TuiTextfieldControllerModule,
        TuiValueAccessorModule,
        PolymorpheusModule]; }, exports: function () { return [TuiInputNumberComponent, TuiInputNumberDirective, TuiTextfieldComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiInputNumberComponent, TuiInputNumberDirective, TuiInputNumberModule };

